import Keycloak from 'keycloak-js'

/**
 * Anmeldung gegen den Backoffice-Realm.
 *
 * Das Zugriffstoken traegt die Rollen und den Anspruch `mandant`. Beides wird
 * nicht in der Oberflaeche entschieden, sondern von der Anwendung geprueft; die
 * Oberflaeche blendet lediglich aus, was ohnehin abgewiesen wuerde.
 */
const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8081',
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'evu-backoffice',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT ?? 'evu-backoffice',
})

/** Wird gesetzt, wenn keine Anmeldung verlangt wird (lokaler Betrieb). */
export const anmeldungAbgeschaltet =
  import.meta.env.VITE_ANMELDUNG_AUS === 'true'

export async function melde_an(): Promise<boolean> {
  if (anmeldungAbgeschaltet) {
    return true
  }
  const angemeldet = await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
  if (angemeldet) {
    // Vor Ablauf erneuern, damit ein laufender Vorgang nicht abbricht.
    setInterval(() => keycloak.updateToken(60).catch(() => keycloak.login()), 30_000)
  }
  return angemeldet
}

export function token(): string | undefined {
  return anmeldungAbgeschaltet ? undefined : keycloak.token
}

export function benutzername(): string {
  if (anmeldungAbgeschaltet) {
    return 'Ortsbetrieb'
  }
  const inhalt = keycloak.tokenParsed as Record<string, unknown> | undefined
  return (inhalt?.['name'] as string) ?? (inhalt?.['preferred_username'] as string) ?? 'Unbekannt'
}

export function rollen(): string[] {
  if (anmeldungAbgeschaltet) {
    return ['sachbearbeiter', 'abrechnung', 'marktkommunikation', 'verwaltung']
  }
  const zugriff = (keycloak.tokenParsed as { realm_access?: { roles?: string[] } } | undefined)
    ?.realm_access
  return zugriff?.roles ?? []
}

export function hat_rolle(...gesuchte: string[]): boolean {
  const eigene = rollen()
  return gesuchte.some((rolle) => eigene.includes(rolle))
}

export function melde_ab(): void {
  if (!anmeldungAbgeschaltet) {
    keycloak.logout()
  }
}
